import { List } from 'immutable';
import I18n from 'I18n';
import { COLUMN_ROLES } from 'reporting-data/constants/relationalReports';
import { flattenFieldExpressions, isFunctionCallExpression } from '../../dataset/expression-utils';
import { getIconNameForType, toPropertyBasicType } from '../../dataset/type-utils';
import { AggregationTypes, Column, DomainTypes, Field } from 'reporting-snowflake/relational/schema/column-records';
import { DATASET_TABLE } from 'reporting-snowflake/relational/schema/table-records';
import { createColumnAlias } from 'reporting-snowflake/relational/utils/column-utils';
import { shouldUseAutoJoin } from 'reporting-snowflake/relational/utils/join-select-utils';
const isDatasetFieldMeasure = field => {
  return field.context === 'AGGREGATE';
};
const isFixedMeasure = field => {
  return isFunctionCallExpression(field.expression) && field.expression.name === 'FIXED';
};
export const processDatasetMeasures = ({
  tableDescription,
  loading,
  dataset
}) => {
  const heading = {
    id: 'dataset-measures-section',
    text: I18n.text('reporting-snowflake.dataset-utils.dataset-measures-header')
  };
  if (!tableDescription || loading || !dataset) {
    return {
      heading,
      measures: List(),
      isLoading: true,
      shouldUseAutoJoin: false
    };
  }
  if (shouldUseAutoJoin(tableDescription)) {
    return {
      heading,
      measures: List(),
      isLoading: false,
      shouldUseAutoJoin: true
    };
  }
  const {
    fields,
    unifiedFieldOrder
  } = dataset.get('datasetDefinition');
  const items = unifiedFieldOrder.map(fieldName => fields.get(fieldName)).filter(field => field && field.derived && !field.hidden && isDatasetFieldMeasure(field)).map(datasetField => {
    const {
      name,
      label,
      type: datasetFieldType
    } = datasetField;
    const type = toPropertyBasicType(datasetFieldType);
    const icon = getIconNameForType(datasetFieldType);
    return {
      text: label,
      icon,
      sourceLabel: DATASET_TABLE,
      objectTypeId: DATASET_TABLE,
      value: Column({
        aggregation: AggregationTypes.DELEGATE,
        domain: DomainTypes.CONTINUOUS,
        role: COLUMN_ROLES.MEASURE,
        alias: createColumnAlias(),
        field: Field({
          name,
          table: DATASET_TABLE,
          type
        })
      })
    };
  });
  return {
    heading,
    measures: List(items),
    isLoading: false,
    shouldUseAutoJoin: false
  };
};
export const processDatasetDerivedFields = ({
  tableDescription,
  loading,
  dataset,
  activeTab
}) => {
  const heading = {
    id: 'dataset-derived-fields-section',
    text: I18n.text('reporting-snowflake.dataset-utils.dataset-derived-fields-header')
  };
  if (!tableDescription || loading || !dataset) {
    return {
      heading,
      fields: List(),
      isLoading: true,
      shouldUseAutoJoin: false
    };
  }
  if (shouldUseAutoJoin(tableDescription)) {
    return {
      heading,
      fields: List(),
      isLoading: false,
      shouldUseAutoJoin: true
    };
  }
  const {
    fields,
    unifiedFieldOrder
  } = dataset.get('datasetDefinition');
  const flattenedFields = flattenFieldExpressions(fields);
  const items = unifiedFieldOrder.map(fieldName => flattenedFields.get(fieldName)).filter(field => {
    if (!field || !field.derived) {
      return false;
    }
    if (activeTab === 'FILTER') {
      return field && !field.hidden && !isDatasetFieldMeasure(field) && !isFixedMeasure(field);
    }
    return field && !field.hidden && !isDatasetFieldMeasure(field);
  }).map(datasetField => {
    const {
      name,
      label,
      type: datasetFieldType
    } = datasetField;
    const type = toPropertyBasicType(datasetFieldType);
    const icon = getIconNameForType(datasetFieldType);
    return {
      text: label,
      value: Field({
        name,
        table: DATASET_TABLE,
        type
      }),
      icon,
      sourceLabel: dataset.get('name'),
      errorMessage: ''
    };
  });
  return {
    heading,
    fields: List(items),
    isLoading: false,
    shouldUseAutoJoin: false
  };
};